/* eslint-disable */
import axios from 'axios';
import gql from 'graphql-tag';
import Logger from '../../logger';

const graphql = require('graphql');
const { print } = graphql;

export interface VerifyCustomerLinkedRequest {
  Brand: string;
  CorrelationId: string;
  Country: string;
  token: string;
}

export interface VerifyCustomerLinkedResult {
  isLinked: boolean | null;
  partyId?: number | null;
  externalId?: string;
  brand?: string;
  country?: string;
  error?: string;
}

const gqlRequest = gql`
  query VerifyCustomerLinked($Request: VerifyCustomerLinkedRequest!) {
    verifyCustomerLinked(Request: $Request) {
      IsTheExternalIdLinked
      Links {
        PartyId
        ExternalId
        Brand
        Country
        CreatedDateTime
        CreatedBy
      }
    }
  }
`;

const verifyCustomerLinked = async (
  payload: VerifyCustomerLinkedRequest,
): Promise<VerifyCustomerLinkedResult> => {
  try {
    const appsyncUrl = process.env.REACT_APP_APPSYNC_URL ?? '';
    const url = `${appsyncUrl}/customerauth/authenticated/graphql`;

    const minimalSessionDetails = {
      correlationId: payload.CorrelationId,
      brand: payload.Brand,
      country: payload.Country,
      source: 'myVW',
      language: '',
    };

    Logger.info(
      `myVW Integration ===> verifyCustomerLinked: request | ${JSON.stringify({
        payload: { Brand: payload.Brand, CorrelationId: payload.CorrelationId, Country: payload.Country },
      })}`,
      'Location ==> myVW service: verifyCustomerLinked',
      minimalSessionDetails,
    );

    const response = await axios({
      url,
      method: 'post',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        Authorization: payload.token,
      },
      data: {
        query: print(gqlRequest),
        variables: {
          Request: {
            Brand: payload.Brand,
            CorrelationId: payload.CorrelationId,
            Country: payload.Country,
          },
        },
      },
    });

    Logger.info(
      `myVW Integration ===> verifyCustomerLinked: response | ${JSON.stringify({
        status: response.status,
        data: response.data,
      })}`,
      'Location ==> myVW service: verifyCustomerLinked',
      minimalSessionDetails,
    );

    const data = response?.data?.data?.verifyCustomerLinked;
    const firstLink = data?.Links?.[0];
    const parsedPartyId = Number(firstLink?.PartyId);

    return {
      isLinked: Boolean(data?.IsTheExternalIdLinked),
      partyId: Number.isFinite(parsedPartyId) && parsedPartyId > 0 ? parsedPartyId : null,
      externalId: firstLink?.ExternalId ?? '',
      brand: firstLink?.Brand ?? payload.Brand,
      country: firstLink?.Country ?? payload.Country,
    };
  } catch (error) {
    const normalizedError = error as Error;
    const errorMessage = normalizedError?.message || normalizedError?.toString() || 'Unknown error';
    console.error('verifyCustomerLinked failed', errorMessage);
    return {
      isLinked: null,
      partyId: null,
      error: errorMessage,
    };
  }
};

export default verifyCustomerLinked;